<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >

        <input-text
            label="* Name"
            name="name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="255"
        />

        <input-text
            label="Title"
            name="title"
            v-model="form.title"
            class="mt-3"
            :error="errors.title ? errors.title[0] : null"
            :maxlength="255"
        />

        <Select
            label="* Type"
            name="type"
            v-model="form.type"
            class="mt-2"
            :options="[
                {value: 'info', name: 'summary (blue)'},
                {value: 'success', name: 'tip (green)'},
                {value: 'warning', name: 'info (yellow)'},
                {value: 'alert', name: 'alert (red)'},
                {value: 'trust', name: 'trust'},
            ]"
            :error="errors.type ? errors.type[0] : null"
        />

        <input-rich-text
            label="* Content"
            name="content"
            v-model="form.content"
            :error="errors.content ? errors.content[0] : null"
            :maxlength="5000"
            :language="form.language"
        />

        <media-reference
            v-model="form.icon"
            class="mt-3"
            label="Icon"
            name="icon_id"
            :media-types="['Icon']"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
        <errors :errors="errors" />
        <div class="py-5">
            <Btn
                :content="
                    data ? 'Update' : 'Create'
                "
                :disabled="submitButtonDisabled"

            />
        </div>
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "AlertBoxForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                name: this.getFormData("name"),
                title: this.getFormData("title"),
                content: this.getFormData("content"),
                type: this.getFormData("type"),
                icon: this.getFormData("icon"),
                icon_id: this.getFormData("icon_id"),
            },
        };
    },
    watch: {
        "form.icon": function(newValue){
            if(newValue) {
                this.form.icon_id = newValue.id
            }
        },
    }
};
</script>
